var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PaymentButton", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: _vm.isVisible,
        expression: "isVisible",
      },
    ],
    staticClass: "kr-payment-button",
    class: _vm.dynamicClasses,
    style: _vm.styles,
    attrs: { "kr-resource": "", type: "button", disabled: _vm.isDisabled },
    on: { click: _vm.btnClick },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }